import { Tooltip, TooltipPosition, TooltipPositionEvent } from '@progress/kendo-react-tooltip';
const arrowWidth = 10;
const arrowHeight = 10;

export default function Tooltips(props: { children?: React.ReactNode }) {
    return (
        <Tooltip
            className=""
            openDelay={0}
            anchorElement="target"
            showOption={{ hover: true }}
            parentTitle={true}
            onPosition={onPosition}
            setCalloutOnPositionAuto={true}
            filter={(e) => e.role !== "slider"}
            showCallout={true}>
            {props.children}
        </Tooltip>
    );
}

function onPosition(e: TooltipPositionEvent): { top: number; left: number } {
    const domRect = getDomRect(e.targetElement);
    const position: TooltipPosition = e.targetElement?.hasAttribute('data-tooltip-left')
        ? 'left'
        : e.targetElement?.hasAttribute('data-tooltip-right')
          ? 'right'
          : e.targetElement?.hasAttribute('data-tooltip-top')
            ? 'top'
            : e.targetElement?.hasAttribute('data-tooltip-bottom')
              ? 'bottom'
              : e.targetElement?.hasAttribute('data-tooltip-left')
                ? 'left'
                : 'top';
    const callout = e.element.querySelector('.k-callout') as HTMLElement | null;
    if (callout) {
        callout.className = calloutClassName(position);
    }
    const left = getLeftPosition(e.mouseLeft, e.element.offsetWidth, domRect, e.anchorElement, position);
    const top = getTopPosition(e.mouseTop, domRect, e.element.offsetHeight, e.anchorElement, position);

    return { left: left, top: top };
}

function getDomRect(currentTarget: any) {
    if (currentTarget !== null) {
        return (currentTarget as any).getBoundingClientRect();
    }
    return document.body.getBoundingClientRect();
}

const getLeftPosition = (left: any, elementWidth: any, targetElement: any, anchorElement: any, position: any) => {
    switch (position) {
        case 'bottom':
            return anchorElement === 'pointer' ? left - elementWidth / 2 : targetElement.left - elementWidth / 2 + targetElement.width / 2;
        case 'left':
            return anchorElement === 'pointer' ? left - elementWidth - arrowWidth : targetElement.left - elementWidth - arrowWidth;
        case 'right':
            return anchorElement === 'pointer' ? left + arrowWidth : targetElement.right + arrowWidth;
        case 'top':
            return anchorElement === 'pointer' ? left - elementWidth / 2 : targetElement.left - elementWidth / 2 + targetElement.width / 2;
        default:
            if (anchorElement === 'pointer') {
                return left < window.screen.availWidth / 2 ? left - arrowWidth : left - elementWidth + arrowWidth;
            }
            return left < window.screen.availWidth / 2 ? targetElement.left : targetElement.right - elementWidth;
    }
};

const getTopPosition = (top: any, targetElement: any, elementHeight: any, anchorElement: any, position: any) => {
    switch (position) {
        case 'bottom':
            return anchorElement === 'pointer' ? top + arrowHeight : targetElement.bottom + arrowHeight;
        case 'left':
            return anchorElement === 'pointer' ? top - elementHeight / 2 : targetElement.top - elementHeight / 2 + targetElement.height / 2;
        case 'right':
            return anchorElement === 'pointer' ? top - elementHeight / 2 : targetElement.top - elementHeight / 2 + targetElement.height / 2;
        case 'top':
            return anchorElement === 'pointer' ? top - elementHeight - arrowHeight : targetElement.top - elementHeight - arrowHeight;
        default:
            if (anchorElement === 'pointer') {
                return top < window.innerHeight / 2 ? top + arrowWidth : top - elementHeight - arrowWidth;
            }
            return top < window.innerHeight / 2 ? targetElement.bottom + arrowHeight : targetElement.top - elementHeight - arrowHeight;
    }
};
const calloutClassName = (position: TooltipPosition) => {
    switch (position) {
        case 'bottom':
            return 'k-callout k-callout-n';
        case 'left':
            return 'k-callout k-callout-e';
        case 'right':
            return 'k-callout k-callout-w';
        case 'top':
            return 'k-callout k-callout-s';
        default:
            return '';
    }
};
